<template>
  <div>
    <v-alert v-if="!preview" dense outlined type="info" class="mb-4">
      Önizleme henüz alınmadı. Form kontrol edildiğinde policy planı burada
      gösterilecek.
    </v-alert>

    <operation-blocked-reasons
      v-if="blockedReasons.length"
      :reasons="blockedReasons"
      title="Uygulama kapalı"
      class="mb-4"
    />

    <v-alert
      v-if="warningMessages.length"
      dense
      outlined
      type="warning"
      class="mb-4"
    >
      <div class="font-weight-medium mb-1">Uygulama öncesi dikkat</div>
      <ul class="mb-0 pl-4">
        <li v-for="warning in warningMessages" :key="warning">
          {{ warning }}
        </li>
      </ul>
    </v-alert>

    <operation-panel
      title="Çözüm Planı"
      subtitle="Uygulamadan önce çözüm planını kontrol edin."
      :tone="blockedReasons.length ? 'warning' : 'primary'"
      :chip-label="blockedReasons.length ? 'Engelli' : 'Önizleme'"
      :chip-color="blockedReasons.length ? 'warning' : 'primary'"
    >
      <operation-timeline
        :items="planActions"
        :default-status="blockedReasons.length ? 'Kontrol' : 'Güvenli'"
        :default-color="blockedReasons.length ? 'warning' : 'success'"
      />
    </operation-panel>
  </div>
</template>

<script>
import OperationBlockedReasons from "./OperationBlockedReasons.vue";
import OperationPanel from "./OperationPanel.vue";
import OperationTimeline from "./OperationTimeline.vue";

export default {
  name: "OperationPreviewPanel",
  components: {
    OperationBlockedReasons,
    OperationPanel,
    OperationTimeline,
  },
  props: {
    preview: {
      type: Object,
      default: null,
    },
  },
  computed: {
    currentPlan() {
      return this.preview
        ? this.preview.resolution_plan || this.preview.plan
        : null;
    },
    blockedReasons() {
      return this.currentPlan ? this.currentPlan.blocked_reasons || [] : [];
    },
    warningMessages() {
      return this.currentPlan ? this.currentPlan.warnings || [] : [];
    },
    planActions() {
      return this.currentPlan ? this.currentPlan.actions || [] : [];
    },
  },
};
</script>
